import { ListLayout } from '@ingrid/luterkort-react';

import { Schema } from '../queries';

interface Props {
  schema: Schema;
  path?: string;
}

export function SchemaDisplayInteger({ schema }: Props) {
  if (schema.type !== 'integer') {
    return null;
  }

  /**
   * Figure out if the value should be a plain integer, or an actual option value (oneOf)
   */
  const value = schema.oneOf?.find(o => o.const === schema.value)?.title ?? schema.value;

  return (
    <ListLayout.Stack>
      <ListLayout.SecondaryText>{schema.title}</ListLayout.SecondaryText>
      <ListLayout.PrimaryText>{value ?? '-'}</ListLayout.PrimaryText>
    </ListLayout.Stack>
  );
}
